import styled from "styled-components";

export const ClockStyled = styled.div`
    border-radius: 10px;
    color: #ffe142;
    background-color: black;
    padding: 10px;
`;